import { isMobile,isTablet,isMobileOnly,isIOS ,isIE,browserVersion} from 'mobile-device-detect';

/**
 *        //https://www.npmjs.com/package/mobile-device-detect
 */

let Instance;

class UserDevice {

    constructor() {
        this._data = {};
        this._data.mobile = isMobile;
        this._data.phone = isMobileOnly;
        this._data.tablet = isTablet;
        this._data.iOS = isIOS;
        this._data.IE = isIE;
        this._data.ver =browserVersion;

        this.init();
    }


    /** @return {boolean} */
    get mobile() {
        return this._data.mobile; // && $(window).innerWidth() < 992
    }

    /** @param {boolean} value*/
    set mobile(value) {
        this._data.mobile = value;
    }


    /** @return {boolean} */
    get tablet() {
        return this._data.tablet;
    }

    /** @param {boolean} value*/
    set tablet(value) {
        this._data.tablet = value;
    }

    /** @return {boolean} */
    get phone() {
        return this._data.phone;
    }

    /** @param {boolean} value*/
    set phone(value) {
        this._data.phone = value;
    }

    /** @return {boolean} */
    get iOS() {
        return this._data.iOS;
    }

    /** @param {boolean} value*/
    set iOS(value) {
        this._data.iOS = value;
    }
    /** @return {boolean} */
    get IE() {
        return this._data.IE;
    }

    /** @param {boolean} value*/
    set IE(value) {
        this._data.IE = value;
    }

    /** @return {int} */
    get ver() {
        return this._data.ver;
    }

    /** @param {int} value*/
    set ver(value) {
        this._data.ver = value;
    }

    /** @return {string} */
    get orientation() {
        return this._data.orientation;
    }


    /** @return {int} */
    get vh() {
        return window.innerHeight * 0.01;
    }

    init() {
        document.documentElement.style.setProperty('--vh', this.vh + 'px');

        const html = document.body.parentElement;
        html.classList.toggle("mobile",this.mobile );
        html.classList.toggle('tablet', this.tablet);
        html.classList.toggle('phone', this.phone);
        html.classList.toggle('ios', this.iOS);
        html.classList.toggle('old-ios', this.iOS && this.ver < 11);


        window.addEventListener("resize", () => {
            document.documentElement.style.setProperty('--vh', this.vh + 'px');
        });

    }

}

function getDevice() {
    if (!Instance)
        Instance = new UserDevice();
    return Instance;
}

export const device = getDevice();

